<template>
	<!-- bridge -->
	<div class='bridge'>

		<!-- background -->
		<div class='bridge__background sticky flex'>
			
			<!-- bridge -->
			<div class='bridge__icon-bridge has-filter-dark-blue' />

			<!-- water -->
			<div class='bridge__icon-water has-filter-white' />

		</div>


		<!-- foreground -->
		<div class='bridge__foreground flex flex-justify-start'>
			<div class='card card-bridge'>
				<div class='card__content'>
					<p class='card__text'>
						<span v-if="lang === 'en'">We build trailbridges to connect people with the resources they need</span>
						<span v-else>Construimos puentes para conectar a las personas con los recursos que necesitan</span>
					</p>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		props: {
			lang: String
		}
	}
</script>